import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'appointment-form/insurance-error-modal';

export const INSURANCE_ERROR_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const insuranceErrorModalActions = {
  open: createAction(INSURANCE_ERROR_MODAL.OPEN),
  close: createAction(INSURANCE_ERROR_MODAL.CLOSE),
};

const initialState = {
  opened: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INSURANCE_ERROR_MODAL.OPEN: {
      return {
        opened: true,
        entity: payload,
      };
    }

    case INSURANCE_ERROR_MODAL.CLOSE: {
      return {
        ...state,
        opened: false,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/handle-insurance-error-modal.js